
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.1.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <menu-content-area> handles displaying content above or below a section.
 *
 *  2025-04-08 (1.1.0) (jhoward)
 *    - Remove "visual_" prefix from class names in <menu-content-area>.
 */

import {defineComponent} from "vue";

export default defineComponent({
  name: "menu-content-area",
  props: {
    content: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'section',
      validate: (value) => ['section', 'page'].indexOf(value)
    },
    position: {
      type: String,
      default: 'top',
      validate: (value) => ['top', 'bottom'].indexOf(value)
    }
  },
  computed: {
    isPageContentArea(): boolean {
      return 'page' === this.type;
    },
    isSectionContentArea(): boolean {
      return 'section' === this.type;
    },
    isPositionTop(): boolean {
      return 'top' === this.position;
    },
    isPositionBottom(): boolean {
      return 'bottom' === this.position;
    },
    containerClasses(): {[key: string]: boolean} {
      return {
        //type=page
        'visual_menu--page': this.isPageContentArea ,
        'visual_menu--content_top': this.isPageContentArea && this.isPositionTop,
        'visual_menu--content_bottom': this.isPageContentArea && this.isPositionBottom,

        //type=section
        'visual_menu--page_section': this.isSectionContentArea,
        'visual_menu--page_section-top': this.isSectionContentArea && this.isPositionTop,
        'visual_menu--page_section-bottom': this.isSectionContentArea && this.isPositionBottom,
      };
    }
  }
})
